import React from "react";
import { Product } from "~/common/Store/models/ProductListing";
interface Props {
  product: Product;
}
export default ({
  product
}: Props) => {
  return <>
      <input name="from" type="hidden" value="add" />
      {!product.grouping && <input className="item_number" name="item_number" type="hidden" value={product.outletAttributes.isOutlet ? "OUTLET" : product.itemNumber} />}
      {product.outletAttributes.isOutlet && <>
          <input className="description" name="description" type="hidden" value={`Outlet Item #${product.outletAttributes.outletProductId} (${product.originalId})`} />
          <input type="hidden" name="qty" value="1" />
        </>}
    </>;
};